unit ShowPdf;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WebBasis, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer, WEBLib.Controls, WEBLib.Dialogs, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCWebBrowser,
  VCL.TMSFNCCustomWEBControl, VCL.TMSFNCWXPDFViewer, VCL.TMSFNCToolBar, WEBLib.ExtCtrls, Web, Vcl.StdCtrls,
  WEBLib.StdCtrls, Vcl.Imaging.pngimage, WebBasis2;

[async] procedure Show_Pdf( sDaten : String ); async;

type
  TfrmShowPdf = class(TfrmWebBasis)
    pdfViewer: TTMSFNCWXPDFViewer;
    WebPanel1: TPanel;
    btnClose: TTMSFNCToolBarButton;
    BtPreviousPage: TImageControl;
    BtNextPage: TImageControl;
    BtZoomIn: TImageControl;
    BtZoomOut: TImageControl;
    BtRotateRight: TImageControl;
    procedure btnCloseClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure pdfViewerViewerInitialized(Sender: TObject);
    procedure BtPreviousPageClick(Sender: TObject);
    procedure BtNextPageClick(Sender: TObject);
    procedure BtZoomInClick(Sender: TObject);
    procedure BtZoomOutClick(Sender: TObject);
    procedure BtRotateLeftClick(Sender: TObject);
    procedure BtRotateRightClick(Sender: TObject);

  private
    sDaten : String;

  public

  protected procedure LoadDFMValues; override; end;


var frmShowPdf: TfrmShowPdf;

implementation

{$R *.dfm}

uses UnitMain ;

//====================================================================================================================//

procedure Show_Pdf( sDaten : String );
begin

  console.log('1') ;

  frmShowPdf := TfrmShowPdf.Create(application);
  frmShowPdf.Caption := 'Pdf: ';
  frmShowPdf.sDaten  := sDaten;
  frmShowPdf.Popup   := True;

  // used to manage Back button handling to close subform
  //window.location.hash := 'subform';

  console.log(sDaten);

  // load file HTML template + controls
  await( TfrmShowPdf, frmShowPdf.Load() );

  frmShowPdf.Caption := 'PDF';

//  await( frmMitarbeiterEdit.Daten_Ins_Formular_Paket );

  Try

    // excute form and wait for close
    await( TModalResult, frmShowPdf.Execute);
//
    //Änderungen speichern
    //If frmShowGrafik.ModalResult = mrOK then frmShowGrafik.Daten_Speichern;
//
  Finally
    frmShowPdf.Free;
  End;

end;

//====================================================================================================================//

procedure TfrmShowPdf.btnCloseClick(Sender: TObject);
begin
  inherited;
  Close;
end;

//====================================================================================================================//

procedure TfrmShowPdf.BtNextPageClick(Sender: TObject);
begin
  inherited;
  pdfViewer.NextPage;
end;

procedure TfrmShowPdf.BtPreviousPageClick(Sender: TObject);
begin
  inherited;
  pdfViewer.PreviousPage;
end;

procedure TfrmShowPdf.BtRotateLeftClick(Sender: TObject);
begin
  inherited;
  pdfViewer.TurnAngleLeft
end;

procedure TfrmShowPdf.BtRotateRightClick(Sender: TObject);
begin
  inherited;
  pdfViewer.TurnAngleRight;
end;

procedure TfrmShowPdf.BtZoomInClick(Sender: TObject);
begin
  inherited;
  pdfViewer.ZoomIn;
end;

procedure TfrmShowPdf.BtZoomOutClick(Sender: TObject);
begin
  inherited;
  pdfViewer.ZoomOut;
end;

//====================================================================================================================//

procedure TfrmShowPdf.pdfViewerViewerInitialized(Sender: TObject);
begin
  inherited;
  pdfViewer.LoadFromBase64( self.sDaten ) ;
end;

//====================================================================================================================//

procedure TfrmShowPdf.WebFormShow(Sender: TObject);
begin
  inherited;

  self.Left   := 0;
  self.Top    := 0;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight;
  Self.Resize;

end;

//====================================================================================================================//

procedure TfrmShowPdf.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pdfViewer := TTMSFNCWXPDFViewer.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  BtPreviousPage := TImageControl.Create(Self);
  BtNextPage := TImageControl.Create(Self);
  BtZoomIn := TImageControl.Create(Self);
  BtZoomOut := TImageControl.Create(Self);
  BtRotateRight := TImageControl.Create(Self);
  btnClose := TTMSFNCToolBarButton.Create(Self);

  pdfViewer.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  BtPreviousPage.BeforeLoadDFMValues;
  BtNextPage.BeforeLoadDFMValues;
  BtZoomIn.BeforeLoadDFMValues;
  BtZoomOut.BeforeLoadDFMValues;
  BtRotateRight.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  try
    Width := 567;
    Height := 567;
    Caption := 'frmShowPdf';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pdfViewer.SetParentComponent(Self);
    pdfViewer.Name := 'pdfViewer';
    pdfViewer.Left := 0;
    pdfViewer.Top := 57;
    pdfViewer.Width := 567;
    pdfViewer.Height := 510;
    pdfViewer.Align := alClient;
    pdfViewer.ParentDoubleBuffered := False;
    pdfViewer.DoubleBuffered := True;
    pdfViewer.TabOrder := 2;
    pdfViewer.AutoClearCache := True;
    pdfViewer.Zoom := 1.000000000000000000;
    SetEvent(pdfViewer, Self, 'OnViewerInitialized', 'pdfViewerViewerInitialized');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 567;
    WebPanel1.Height := 57;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 2;
    WebPanel1.TabOrder := 3;
    BtPreviousPage.SetParentComponent(WebPanel1);
    BtPreviousPage.Name := 'BtPreviousPage';
    BtPreviousPage.Left := 97;
    BtPreviousPage.Top := 3;
    BtPreviousPage.Width := 48;
    BtPreviousPage.Height := 48;
    BtPreviousPage.Hint := 'Previous page';
    BtPreviousPage.HeightPercent := 100.000000000000000000;
    BtPreviousPage.WidthPercent := 100.000000000000000000;
    BtPreviousPage.ChildOrder := 1;
    BtPreviousPage.ShowHint := True;
    SetEvent(BtPreviousPage, Self, 'OnClick', 'BtPreviousPageClick');
    BtPreviousPage.Picture.LoadFromFile('ShowPdf.WebPanel1.BtPreviousPage.Picture.png');
    BtNextPage.SetParentComponent(WebPanel1);
    BtNextPage.Name := 'BtNextPage';
    BtNextPage.Left := 148;
    BtNextPage.Top := 3;
    BtNextPage.Width := 48;
    BtNextPage.Height := 48;
    BtNextPage.Hint := 'Next page';
    BtNextPage.HeightPercent := 100.000000000000000000;
    BtNextPage.WidthPercent := 100.000000000000000000;
    BtNextPage.ChildOrder := 2;
    BtNextPage.ShowHint := True;
    SetEvent(BtNextPage, Self, 'OnClick', 'BtNextPageClick');
    BtNextPage.Picture.LoadFromFile('ShowPdf.WebPanel1.BtNextPage.Picture.png');
    BtZoomIn.SetParentComponent(WebPanel1);
    BtZoomIn.Name := 'BtZoomIn';
    BtZoomIn.Left := 208;
    BtZoomIn.Top := 3;
    BtZoomIn.Width := 48;
    BtZoomIn.Height := 48;
    BtZoomIn.Hint := 'Zoom in';
    BtZoomIn.HeightPercent := 100.000000000000000000;
    BtZoomIn.WidthPercent := 100.000000000000000000;
    BtZoomIn.ChildOrder := 3;
    BtZoomIn.ShowHint := True;
    SetEvent(BtZoomIn, Self, 'OnClick', 'BtZoomInClick');
    BtZoomIn.Picture.LoadFromFile('ShowPdf.WebPanel1.BtZoomIn.Picture.png');
    BtZoomOut.SetParentComponent(WebPanel1);
    BtZoomOut.Name := 'BtZoomOut';
    BtZoomOut.Left := 258;
    BtZoomOut.Top := 3;
    BtZoomOut.Width := 48;
    BtZoomOut.Height := 48;
    BtZoomOut.Hint := 'Zoom out';
    BtZoomOut.HeightPercent := 100.000000000000000000;
    BtZoomOut.WidthPercent := 100.000000000000000000;
    BtZoomOut.ChildOrder := 4;
    BtZoomOut.ShowHint := True;
    SetEvent(BtZoomOut, Self, 'OnClick', 'BtZoomOutClick');
    BtZoomOut.Picture.LoadFromFile('ShowPdf.WebPanel1.BtZoomOut.Picture.png');
    BtRotateRight.SetParentComponent(WebPanel1);
    BtRotateRight.Name := 'BtRotateRight';
    BtRotateRight.Left := 316;
    BtRotateRight.Top := 3;
    BtRotateRight.Width := 48;
    BtRotateRight.Height := 48;
    BtRotateRight.Hint := 'Rotate right';
    BtRotateRight.HeightPercent := 100.000000000000000000;
    BtRotateRight.WidthPercent := 100.000000000000000000;
    BtRotateRight.ChildOrder := 6;
    BtRotateRight.ShowHint := True;
    SetEvent(BtRotateRight, Self, 'OnClick', 'BtRotateRightClick');
    BtRotateRight.Picture.LoadFromFile('ShowPdf.WebPanel1.BtRotateRight.Picture.png');
    btnClose.SetParentComponent(WebPanel1);
    btnClose.Name := 'btnClose';
    btnClose.Left := 7;
    btnClose.Top := 5;
    btnClose.Width := 88;
    btnClose.Height := 41;
    btnClose.Cursor := crHandPoint;
    btnClose.ParentDoubleBuffered := False;
    btnClose.DoubleBuffered := True;
    btnClose.Font.Charset := DEFAULT_CHARSET;
    btnClose.Font.Color := clWindowText;
    btnClose.Font.Height := -11;
    btnClose.Font.Name := 'Segoe UI';
    btnClose.Font.Style := [];
    btnClose.ParentColor := True;
    btnClose.TabOrder := 0;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnClose.Text := '';
    btnClose.Bitmaps.Clear;
    with btnClose.Bitmaps.Add do
    begin
      Bitmap.LoadFromFile('ShowPdf.btnClose.Bitmaps.Bitmap.png');
      BitmapName := 'LINKS';
    end;
    btnClose.BitmapVisible := True;
    btnClose.ControlIndex := 0;
  finally
    pdfViewer.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    BtPreviousPage.AfterLoadDFMValues;
    BtNextPage.AfterLoadDFMValues;
    BtZoomIn.AfterLoadDFMValues;
    BtZoomOut.AfterLoadDFMValues;
    BtRotateRight.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
  end;
end;

end.
